/* eslint-disable react-hooks/exhaustive-deps */
import { Alert, Button, Form, Input, Select } from "antd";
import { FormInstance } from "antd/es/form/Form";
import { useAtom } from "jotai";
import React, { useEffect, useState, createRef } from "react";
import { storeExchangeAtom } from "lib/core-react/store/store";
import { renderOptionsFromEnum } from "components/Form/forms";
import { useCreateExchangeGroup } from "lib/core-react/hooks/private/useExchangeGroup";
import { useGetExchange } from "lib/core-react/hooks/private/useExchange";
import { ExchangeListCollectionModel } from "models/exchangeListCollectionModel";
import { IExchangeGroupPostRequest } from "types/exchangeGroupCollection";

interface IProps {
  setIsShowCreateModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const CreateExchangeGroup = ({ setIsShowCreateModal }: IProps) => {
  const { getExchange } = useGetExchange();
  const [{ data: exchangeDataAtom, isLoading: exchangeLoading }] =
    useAtom(storeExchangeAtom);

  const { createExchangeGroup, isLoading, isError } = useCreateExchangeGroup();
  const [isErrorVisible, setIsErrorVisible] = useState(false);

  const formRef: React.Ref<FormInstance<any>> = createRef();
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [form]);

  //hide error message after 5 sec
  useEffect(() => {
    if (isErrorVisible) {
      setTimeout(() => {
        setIsErrorVisible(false);
      }, 5000);
    }
  }, [isErrorVisible]);

  useEffect(() => {
    getExchange();
  }, []);

  const ExchangeData =
    exchangeDataAtom && new ExchangeListCollectionModel(exchangeDataAtom);

  const onFinish = async (value: IExchangeGroupPostRequest) => {
    const payload = {
      name: value.name,
      exchange_list_id: value.exchange_list_id,
    };

    try {
      await createExchangeGroup(payload as IExchangeGroupPostRequest);
      setIsShowCreateModal(false);
      setIsErrorVisible(false);
    } catch (error) {
      setIsErrorVisible(true);
    }
  };

  return (
    <Form
      onFinish={onFinish}
      form={form}
      layout="vertical"
      name="Create Exchange Group"
      ref={formRef}
    >
      <Form.Item
        rules={[
          {
            required: true,
            message: "Exchange group name is required",
          },
        ]}
        label="Name"
        name="name"
      >
        <Input placeholder="Exchange group name" />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: "Exchange list is required" }]}
        name="exchange_list_id"
        label="Exchange List"
      >
        <Select
          loading={exchangeLoading}
          placeholder="Please select a exchange list"
        >
          {ExchangeData?.getExchangeListIdsAsObject() &&
            renderOptionsFromEnum(ExchangeData?.getExchangeListIdsAsObject())}
        </Select>
      </Form.Item>

      <Form.Item>
        <Button
          loading={isLoading}
          type="primary"
          htmlType="submit"
          style={{ width: "100%" }}
        >
          Submit
        </Button>
      </Form.Item>

      {isErrorVisible && (
        <Alert
          style={{ marginTop: "7px" }}
          message={isError}
          closable
          afterClose={() => setIsErrorVisible(false)}
          type="error"
          showIcon
        />
      )}
    </Form>
  );
};

export default CreateExchangeGroup;
